import { render, staticRenderFns } from "./DishOrders.vue?vue&type=template&id=4a015b81&scoped=true&"
import script from "./DishOrders.vue?vue&type=script&lang=js&"
export * from "./DishOrders.vue?vue&type=script&lang=js&"
import style0 from "./DishOrders.vue?vue&type=style&index=0&id=4a015b81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a015b81",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
installComponents(component, {VBtn,VFlex,VIcon,VLayout,VSnackbar})
